var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCardImage4Min(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 270,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M74.652 39.52c23.428-3.48 47.549-1.083 70.777-5.86 24.296-5 46.421-17.585 69.84-25.942 23.419-8.357 50.465-12.114 72.191.133 13.302 7.504 23.09 20.213 30.769 33.659 15.135 26.516 23.338 56.577 23.817 87.282.217 15.222-1.509 30.551-6.073 45.045-15.254 48.437-61.424 81.962-110.109 92.3-53.467 11.359-111.602-2.487-154.778-36.688-36.764-29.174-73.12-81.19-60.65-128.57 8.268-31.51 29.093-56.136 64.216-61.359z",
    fill: "#F7941D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m258.428 169.236-26.673 20.204a2.612 2.612 0 0 1-1.976.504 2.65 2.65 0 0 1-1.746-1.072L216.97 173.57a2.576 2.576 0 0 1-.434-.959 2.776 2.776 0 0 1 .071-1.579c.176-.508.496-.951.918-1.272l26.681-20.204a2.65 2.65 0 0 1 1.062-.479c.384-.079.78-.07 1.16.026a2.72 2.72 0 0 1 1.501 1.021l11.063 15.311a2.756 2.756 0 0 1 .487 2.02 2.763 2.763 0 0 1-.352.998 2.702 2.702 0 0 1-.699.783z",
    fill: "#F7941D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m246.428 149.103-4.937 22.7-24.955.808a2.776 2.776 0 0 1 .071-1.579c.176-.508.496-.951.918-1.272l26.681-20.204a2.65 2.65 0 0 1 1.062-.479c.384-.079.78-.07 1.16.026z",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m232.536 172.096.816 16.128 25.076-18.988-15.176-5.55-1.761 8.117-8.955.293z",
    fill: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m263.391 40.07-29.796 43.456-5.727-16.261a543.741 543.741 0 0 0-58.317 19.458c-21.987 8.96-43.159 20.097-49.241 31.607-13.944 26.439 18.811 38.126 18.811 38.126a88.1 88.1 0 0 1-18.698-.461c-16.339-2.194-36.625-10.294-30.751-37.665 4.642-21.625 34.864-39.813 64.556-52.77h.043c4.338-1.883 8.677-3.65 12.894-5.33l.121-.052a465.971 465.971 0 0 1 48.53-15.986l-2.855-14.228 50.43 10.107z",
    fill: "#F7941D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.31 118.33c-13.944 26.439 18.811 38.127 18.811 38.127a88.1 88.1 0 0 1-18.698-.462 103.616 103.616 0 0 1-6.872-9.174c-18.803-27.993 21.527-50.054 21.527-50.054 3.358-12.548 19.15-22.93 19.15-22.93V65.56h.043l12.894-5.329.121-.053 2.838 24.263-.573 2.264c-21.987 8.979-43.159 20.116-49.241 31.625z",
    fill: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.746 209.627a11.264 11.264 0 0 0-1.44 4.52 7.916 7.916 0 0 0 1.449 4.441c1.883 2.859 4.77 4.866 8.061 5.604.43.135.894.113 1.31-.062.285-.179.507-.447.633-.764.79-1.643.469-3.597-.052-5.329-.52-1.732-1.232-3.49-1.154-5.328.131-3.437 4.929-10.071-.659-11.688-4.66-1.385-6.664 5.542-8.148 8.606z",
    fill: "#B2857F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.467 214.112s-1.649 1.385-1.337 2.913c.313 1.527 6.239 12.176 14.682 10.959 8.442-1.217-5.424-9.769-5.424-9.769l-7.921-4.103z",
    fill: "#F7941D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.018 210.178c.345.013.675.153.929.394.253.241.413.568.45.92a6.166 6.166 0 0 0 1.364 2.732 5.966 5.966 0 0 0 2.489 1.709c2.204.612 4.217-1.27 5.206-.738.989.533 3.766 7.949 3.037 10.063-.729 2.113-4.148 2.06-7.185.612-3.037-1.447-8.572-7.229-8.998-9.511-.425-2.283 1.501-5.568 2.708-6.181z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.946 221.909a12.52 12.52 0 0 0-1.389 5.098 8.878 8.878 0 0 0 1.823 4.822c2.228 3.092 5.534 5.185 9.232 5.844.483.131.996.084 1.449-.133.305-.222.541-.531.677-.888.798-1.865.338-4.023-.313-5.942-.651-1.918-1.518-3.809-1.553-5.834 0-3.819 5.007-11.448-1.275-12.967-5.25-1.27-7.159 6.528-8.651 10z",
    fill: "#B2857F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.501 227.123s-1.735 1.625-1.345 3.303c.391 1.679 7.488 13.233 16.825 11.457 9.336-1.776-6.473-10.524-6.473-10.524l-9.007-4.236z",
    fill: "#F7941D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.147 222.575c.389-.004.765.136 1.06.394.295.258.489.616.546 1.009a6.77 6.77 0 0 0 1.64 2.959 6.539 6.539 0 0 0 2.846 1.757c2.481.569 4.642-1.607 5.735-1.074 1.093.533 4.564 8.659 3.835 11.03-.729 2.371-4.52 2.495-7.965 1.039-3.445-1.457-9.874-7.62-10.412-10.133-.538-2.514 1.405-6.235 2.715-6.981z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.662 129.29c.236.042.468.104.694.186 5.484 2.132 12.087 11.634 15.818 16.146a80.562 80.562 0 0 1 11.991 18.97c6.3 14.396 6.881 32.282-1.97 45.195l-6.802-1.456a2.914 2.914 0 0 1-1.605-.72 3.179 3.179 0 0 1-.46-2.407 63.904 63.904 0 0 0-.668-14.893 30.317 30.317 0 0 0-2.985-9.662c-2.135-3.935-5.501-6.981-8.781-9.965-10.412-9.44-19.749-19.201-24.911-32.549 4.659-2.344 14.655-9.751 19.679-8.845z",
    fill: "#473F47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.905 136.537a2.9 2.9 0 0 1 .633.355c4.85 3.375 9.111 14.209 11.714 19.467a82.151 82.151 0 0 1 7.34 21.314c2.838 15.498-.659 33.029-12.208 43.517l-6.291-3.046a2.998 2.998 0 0 1-1.397-1.075 3.213 3.213 0 0 1 .104-2.46 63.521 63.521 0 0 0 2.742-14.644 30.41 30.41 0 0 0-.702-10.107c-1.172-4.325-3.758-8.091-6.265-11.785-7.939-11.652-14.829-23.384-16.807-37.593 5.058-1.173 16.468-5.986 21.137-3.943z",
    fill: "#473F47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.165 102.709a.553.553 0 0 1 0 .115c.078 1.483.555 2.789.182 4.298-.399 1.679-1.926 3.198-3.592 2.949-1.388-.204-2.334-1.483-3.401-2.416a14.981 14.981 0 0 0-3.679-2.22 87.972 87.972 0 0 0-5.311-2.309c-1.145-.462-3.331-.746-3.817-1.945-.486-1.199-.33-3.09-.469-4.36l-2.16-20.152 20.104 16.874a30.948 30.948 0 0 1 1.917 5.746c.192 1.129.268 2.275.226 3.42z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.241 104.929c.121 1.19.39 2.371.529 3.552.729 6.563-.061 13.517 2.542 19.743.59 1.385 1.354 2.859 1.007 4.334a5.411 5.411 0 0 1-2.403 2.948c-5.311 3.801-11.758 5.498-18.04 7.105-4.729 1.226-11.384 3.455-16.104 1.306-2.013-.889-2.881-2.949-3.705-4.974-2.603-6.447-3.974-13.552-5.206-20.426-.156-.888-.321-1.776-.468-2.709a261.523 261.523 0 0 1-2.404-18.757c-.399-4.582-.581-9.555 1.97-13.321 3.384-5.027 10.551-8.881 16.13-10.657a18.96 18.96 0 0 1 5.579-.95c2.7.129 5.359.73 7.861 1.776 2.976 1.11 5.623 2.034 7.315 4.733a39.818 39.818 0 0 1 4.269 10.071c.9 3.32 1.347 6.75 1.327 10.196 0 1.687-.225 3.392-.216 5.071-.028.319-.022.641.017.959z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M170.028 145.071c-1.805.773-6.282-.497-7.731-.595-.868-.053-1.735-.409-2.603-.515-4.338-.613-6.187-12.78-6.941-15.986-2.031-8.57-4.686-17.38-5.744-26.083-.4-3.366-.686-6.803.052-10.098.737-3.295 2.603-6.474 5.596-7.993 5.206-2.611 8.72 14.787 9.857 18.339 1.423 4.441 2.855 8.881 4.269 13.322.625 1.989.824 4.2 1.892 6.021 1.622 2.762 2.993 2.238 5.709 1.776 5.701-1.012 11.028-3.49 16.642-4.875a1.77 1.77 0 0 1 1.432.071c.302.254.508.609.581 1.003.331 1.122.512 2.284.538 3.455.033.335-.015.674-.139.986a2.201 2.201 0 0 1-.789.763 42.716 42.716 0 0 1-12.347 5.746c-3.471.995-6.76 2.665-9.102 5.631-2.109 2.664.633 5.471-.512 8.357a1.214 1.214 0 0 1-.66.675z",
    fill: "#020202"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m166.072 131.652 33.267-11.483 24.399 14.245-33.953 14.245-23.713-17.007z",
    fill: "#F7941D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m166.072 131.652 33.267-11.483 24.399 14.245-33.953 14.245-23.713-17.007z",
    fill: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m167.443 129.814 33.266-11.483 24.4 14.245-33.953 14.245-23.713-17.007z",
    fill: "#F7941D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m192.788 144.858 27.522-12.442-13.431-7.549-27.367 10.604 13.276 9.387z",
    fill: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.156 146.821h32.807l28.243-18.002-27.097 3.757-33.953 14.245z",
    fill: "#F7941D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.963 64.307a96.99 96.99 0 0 1-1.093 3.748c-.868 2.842-2.603 5.435-5.623 6.119-.667.131-1.343.214-2.021.249h-.452a.067.067 0 0 1-.06 0h-.078a3.313 3.313 0 0 0-1.007.106.56.56 0 0 0-.26.08c-.868.409-.799 1.847-.738 2.664.214.92.11 1.886-.295 2.736 0 0 0 .053-.052.089a2.68 2.68 0 0 1-.854.637 2.63 2.63 0 0 1-1.029.25 5.816 5.816 0 0 1-4.156-1.296 7.014 7.014 0 0 1-1.588-2.265 5.325 5.325 0 0 1-.295-.755 4.992 4.992 0 0 1-.113-1.34c.016-.691.08-1.38.191-2.06.32-1.346.572-2.706.755-4.077.012-.695.058-1.389.139-2.078.111-.441.192-.89.243-1.342 0-1.305-.651-2.566-.659-3.89a19.61 19.61 0 0 1 .355-3.898 15.56 15.56 0 0 1 3.15-6.936c2.976-3.553 8.252-5.329 12.399-3.304a8.998 8.998 0 0 1 4.486 5.009c1.388 3.739-.347 7.904-1.345 11.554zM175.642 128.419a60.478 60.478 0 0 1 2.195-.231 3.214 3.214 0 0 1 1.302.08c.208.056.399.168.551.324.153.156.262.351.317.564a1.06 1.06 0 0 0 .095.471.692.692 0 0 0 .434.24c2.603.692 5.293 1.776 6.846 3.969a1.66 1.66 0 0 1 .347 1.563c-.356.746-1.397.64-2.178.418a.991.991 0 0 1 0 1.119c-.117.161-.271.29-.447.377a1.178 1.178 0 0 1-.568.12 2.093 2.093 0 0 0-.781 0 1.946 1.946 0 0 0-.486.329 3.17 3.17 0 0 1-2.508.462c-.867-.134-1.735-.436-2.603-.507-1.345-.106-2.551.347-3.8-.213a18.166 18.166 0 0 0-4.339-1.545 2.25 2.25 0 0 1-1.258-.666 2.218 2.218 0 0 1 0-1.936 9.909 9.909 0 0 1 1.198-3.082c.737-1.066 1.969-1.252 3.175-1.465.886-.151 1.675-.267 2.508-.391z",
    fill: "#B2857F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.941 83.721c-6.377 10.808-12.677 23.331-14.49 35.924-.477 3.313-.738 7.22.781 10.329 2.482 5.062 10.924 6.047 15.783 6.554a97.634 97.634 0 0 0 17.51.239.777.777 0 0 0 .71-.227.83.83 0 0 0 .21-.732l.243-5.746c.04-.268.004-.542-.104-.79a1.493 1.493 0 0 0-.56-.414 1.446 1.446 0 0 0-.681-.11 33.81 33.81 0 0 1-9.909-2.354c-3.011-1.225-8.894-4.44-8.469-8.49.234-2.273 2.673-5.044 3.879-6.838 2.898-4.307 6.021-8.481 9.215-12.567 0 0 .312-23.241-14.118-14.778z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.965 59.085a3.106 3.106 0 0 0 1.19-.57c.353-.275.646-.622.858-1.02.356 1.022 2.039.71 2.464-.293.425-1.003 0-2.14-.381-3.144a2.447 2.447 0 0 0 1.073-.57 2.53 2.53 0 0 0 .679-1.025 2.59 2.59 0 0 0 .12-1.232 2.548 2.548 0 0 0-.467-1.142c-.286-.329-.685-.613-.763-1.057a2.493 2.493 0 0 1 .147-.995 3.037 3.037 0 0 0-.236-1.527 2.959 2.959 0 0 0-.953-1.2 8.494 8.494 0 0 0-2.811-1.296c.27-.45.371-.984.283-1.504a2.177 2.177 0 0 0-.76-1.32 4.936 4.936 0 0 0-2.855-1.048c-1.501-.169-3.158-.098-4.338.888a4.184 4.184 0 0 0-5.206.568 2.05 2.05 0 0 1-.972.746 1.701 1.701 0 0 1-.816-.142 5.738 5.738 0 0 0-3.47-.364 2.397 2.397 0 0 0-1.429 1.011 2.5 2.5 0 0 0-.385 1.733c-.431.053-.836.24-1.16.535a2.183 2.183 0 0 0-.653 1.117c-.02.271-.103.533-.243.764-.252.302-.694.284-1.068.32-.711.063-1.373.4-1.854.94a2.948 2.948 0 0 0-.737 1.98c.007.73.283 1.432.773 1.965.49.532 1.158.855 1.87.905a2.71 2.71 0 0 0 .374 2.096c.459.755 1.075.808 1.683 1.279.356.284.217.31.199.888a9.71 9.71 0 0 0 .079 1.59c.118 1.014.366 2.009.737 2.957.26.684.59 1.341.824 2.034.323 1.06.538 2.153.642 3.26l1.467-4.246a.335.335 0 0 0 0-.178.367.367 0 0 0-.156-.186 3.647 3.647 0 0 1-1.276-2.036 3.722 3.722 0 0 1 .252-2.405 1.47 1.47 0 0 1 .45-.595c.198-.156.431-.256.678-.293.59 0 1.041.524 1.327 1.048.305.559.536 1.156.686 1.776a9.823 9.823 0 0 1 1.622-2.664c.287-.328.634-.888 1.094-.72.46.17.676 1.022.867 1.333a5.42 5.42 0 0 0 1.831-1.208 3.31 3.31 0 0 0 .327 1.79 3.204 3.204 0 0 0 1.218 1.327c1.093.524 2.681-.222 2.681-1.465 0 .56 2.369-.382 2.542-.488.183.359.467.654.815.847.347.193.744.275 1.137.236z",
    fill: "#473F47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.521 74.467a11.55 11.55 0 0 0 2.108.089.56.56 0 0 0-.26.08c-.868.408-.799 1.847-.738 2.664.214.92.11 1.886-.295 2.736a2.673 2.673 0 0 1-.798-.116 2.158 2.158 0 0 1-.72-.435 5.245 5.245 0 0 1-1.653-2.552c-.291-1-.283-2.066.022-3.06a9.603 9.603 0 0 0 2.334.594z",
    fill: "#96625E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.907 90.941s15.887 11.999 13.692 23.979a997.578 997.578 0 0 1-3.87 20.009l-7.436-4.441s4.972-16.793-5.406-24.094c-10.377-7.3 3.02-15.453 3.02-15.453z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m202.974 130.32-.711 3.774a3.343 3.343 0 0 0-.052 1.466c.048.242.174.462.358.623.184.161.415.254.657.265.52 0 .963-.586 1.483-.48.186.057.362.144.521.258 1.111.621 2.456 0 3.627-.56a.947.947 0 0 1 .616-.115c.252.071.408.328.625.488a1.222 1.222 0 0 0 1.414-.089c.393-.334.693-.769.868-1.261.467-1.05.67-2.203.589-3.354a7.013 7.013 0 0 0-1.049-3.235 5.916 5.916 0 0 0-2.533-1.865 5.788 5.788 0 0 0-3.107-.285c-2.256.365-2.898 2.176-3.306 4.37z",
    fill: "#B2857F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.785 148.659h32.807l28.244-18.002-27.098 3.757-33.953 14.245z",
    fill: "#F7941D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m191.156 146.821-1.371 1.838h32.807l1.371-1.838h-32.807z",
    fill: "url(#g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m252.206 128.819-1.37 1.838-28.244 18.002 1.371-1.838 28.243-18.002z",
    fill: "#F7941D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m252.206 128.819-1.37 1.838-28.244 18.002 1.371-1.838 28.243-18.002z",
    fill: "url(#h)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m225.438 133.375 22.439-3.206-23.402 14.689-25.536.453 26.499-11.936z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m187.208 131.385 12.703-4.822-6.126-4.583-13.032 4.583 6.455 4.822z",
    fill: "url(#i)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m160.024 181.092-50.404 23.553a4.36 4.36 0 0 1-3.4.123 4.499 4.499 0 0 1-2.492-2.37l-12.893-28.917a4.294 4.294 0 0 1-.39-1.714 4.622 4.622 0 0 1 .66-2.56 4.47 4.47 0 0 1 1.942-1.747l50.404-23.553a4.404 4.404 0 0 1 3.792.054 4.48 4.48 0 0 1 2.1 2.193l12.876 28.926a4.64 4.64 0 0 1 .119 3.471 4.554 4.554 0 0 1-.91 1.506 4.433 4.433 0 0 1-1.404 1.035z",
    fill: "#F7941D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m160.024 181.092-50.404 23.553a4.36 4.36 0 0 1-3.4.123 4.499 4.499 0 0 1-2.492-2.37l-12.893-28.917a4.294 4.294 0 0 1-.39-1.714 4.622 4.622 0 0 1 .66-2.56 4.47 4.47 0 0 1 1.942-1.747l50.404-23.553a4.404 4.404 0 0 1 3.792.054 4.48 4.48 0 0 1 2.1 2.193l12.876 28.926a4.64 4.64 0 0 1 .119 3.471 4.554 4.554 0 0 1-.91 1.506 4.433 4.433 0 0 1-1.404 1.035z",
    fill: "url(#j)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m162.358 180.053-50.404 23.553a4.36 4.36 0 0 1-3.4.123 4.494 4.494 0 0 1-2.491-2.37l-12.894-28.908a4.525 4.525 0 0 1-.4-1.714 4.647 4.647 0 0 1 .662-2.562 4.495 4.495 0 0 1 1.942-1.754l50.403-23.544a4.37 4.37 0 0 1 3.397-.123c1.103.419 2 1.268 2.495 2.361l12.894 28.926a4.63 4.63 0 0 1 .115 3.474 4.54 4.54 0 0 1-.913 1.505 4.43 4.43 0 0 1-1.406 1.033z",
    fill: "#F7941D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m149.551 142.877-15.74 35.329-41.041-7.513a4.645 4.645 0 0 1 .662-2.562 4.489 4.489 0 0 1 1.94-1.754l50.404-23.544a4.35 4.35 0 0 1 3.775.044z",
    fill: "url(#k)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m119.095 175.506-4.121 26.634 47.384-22.131-22.916-14.441-5.631 12.638-14.716-2.7z",
    fill: "url(#l)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m270.272 123.801-32.556-6.581a2.629 2.629 0 0 1-.959-.404 2.733 2.733 0 0 1-1.132-1.731 2.79 2.79 0 0 1 0-1.062l3.601-18.65c.063-.35.196-.682.39-.977a2.674 2.674 0 0 1 1.192-1.013 2.601 2.601 0 0 1 1.542-.159l32.555 6.58c.385.075.75.237 1.065.476.316.238.574.546.757.901.294.557.392 1.199.278 1.821l-3.61 18.65a2.738 2.738 0 0 1-1.125 1.739 2.607 2.607 0 0 1-1.998.41z",
    fill: "#F7941D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m276.727 101.163-19.714 11.546-17.353-18.33a2.67 2.67 0 0 1 1.192-1.014 2.598 2.598 0 0 1 1.541-.16l32.555 6.582c.378.08.734.245 1.041.483.308.238.56.543.738.893z",
    fill: "url(#m)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m250.775 106.128-11.098 11.483 30.595 6.19-6.213-15.222-7.046 4.13-6.238-6.581z",
    fill: "url(#n)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 186.436,
    y1: 120.808,
    x2: 204.742,
    y2: 146.582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 220.997,
    y1: 135.209,
    x2: 244.834,
    y2: 190.832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 238.844,
    y1: 174.538,
    x2: -15.211,
    y2: 4.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 197.863,
    y1: 117.371,
    x2: 175.659,
    y2: 229.426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 184.033,
    y1: 120.844,
    x2: 260.941,
    y2: 181.413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 181.065,
    y1: 163.659,
    x2: 324.151,
    y2: 79.443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 228.71,
    y1: 126.75,
    x2: 279.429,
    y2: 193.533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 204.353,
    y1: 151.907,
    x2: 314.127,
    y2: 219.473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 133.872,
    y1: 169.263,
    x2: 29.083,
    y2: 237.519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 112.711,
    y1: 111.212,
    x2: 132.044,
    y2: 210.655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 79.873,
    y1: 132.602,
    x2: 236.707,
    y2: 281.452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 269.624,
    y1: 72.622,
    x2: 243.629,
    y2: 127.214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 246.348,
    y1: 71.283,
    x2: 269.906,
    y2: 200.118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h350v270H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardImage4Min);
export default __webpack_public_path__ + "static/media/Card Image 4-min.947d0ecf39e56f34a2848a1c9cf5d3f9.svg";
export { ForwardRef as ReactComponent };